import React from 'react'
import t from '../../../../../translations/main'
import utils from '../../../../../components/Organisms/Form/utils'
import Font from 'src/components/Core/Typography/Font/Font'
import globalConfig from 'src/components/Organisms/Form/config'

const getWordComponent = (word: string) => {
  const isWordValueOrLots = word.includes('value') || word.includes('lots')
  return (
    <Font key={`${word}`} ellipsis={false} margin='auto' width='100%' bold={!isWordValueOrLots}>
      {t(`onboarding.forms.IndividualAccount.ExperienceForm.visualOnly.${isWordValueOrLots ? word.split('-')[0] : word}`)}
    </Font>
  )}

const config = utils.injectTranslation({
  id: 'ExperienceForm',
  path: 'onboarding.forms.IndividualAccount.ExperienceForm.inputs',
  content: [
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'grid',
          content: [
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '2fr 1fr 2fr 2fr 0.5fr',
                border: '1px #CDD2DC solid',
                backgroundColor: 'neutral-1',
                padding: '16px',
                boxSizing: 'border-box',
                marginTop: '8px'
              },
              content: [
                {
                  componentType: '',
                  visualComponent: getWordComponent('typeOfInvestment')
                },
                {
                  componentType: '',
                  visualComponent: getWordComponent('numberOfYears')
                },
                {
                  componentType: '',
                  visualComponent: getWordComponent('averageFrequency')
                },
                {
                  componentType: '',
                  visualComponent: getWordComponent('sizeValue')
                },
              ]
            },
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '2fr 1fr 2fr 2fr 0.5fr',
                border: '1px #CDD2DC solid',
                topBorder: '0',
                padding: '16px',
                boxSizing: 'border-box'
              },
              content: [
                {
                  componentType: '',
                  visualComponent: getWordComponent('shares')
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'sharesNoOfYearsTraded',
                    pattern: globalConfig?.regex?.number,
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: 'radioGroup',
                  props: {
                    name: 'sharesFrequencyOfTrades',
                    minHeight: '0',
                    flexWrapperMinHeight: '0',
                    removeButtonMargins: true,
                    removeLabelEllipsis: true,
                    flexProperties: true,
                    dataList: [
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed1',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.lessThanTen'),
                        value: 'lessThanTen',
                      },
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed2',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.moreOrEqualThanTen'),
                        value: 'moreOrEqualThanTen',
                      },
                    ],
                    required: true
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'sharesValueOfAverageDeal',
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: '',
                  visualComponent: getWordComponent('value-1')
                },
              ]
            },
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '2fr 1fr 2fr 2fr 0.5fr',
                border: '1px #CDD2DC solid',
                topBorder: '0',
                padding: '16px',
                boxSizing: 'border-box'
              },
              content: [
                {
                  componentType: '',
                  visualComponent: getWordComponent('bonds')
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'bondsNoOfYearsTraded',
                    pattern: globalConfig?.regex?.number,
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: 'radioGroup',
                  props: {
                    name: 'bondsFrequencyOfTrades',
                    minHeight: '0',
                    flexWrapperMinHeight: '0',
                    removeButtonMargins: true,
                    removeLabelEllipsis: true,
                    flexProperties: true,
                    dataList: [
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed1',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.lessThanTen'),
                        value: 'lessThanTen',
                      },
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed2',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.moreOrEqualThanTen'),
                        value: 'moreOrEqualThanTen',
                      },
                    ],
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'bondsValueOfAverageDeal',
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: '',
                  visualComponent: getWordComponent('value-2')
                },
              ]
            },
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '2fr 1fr 2fr 2fr 0.5fr',
                border: '1px #CDD2DC solid',
                topBorder: '0',
                padding: '16px',
                boxSizing: 'border-box'
              },
              content: [
                {
                  componentType: '',
                  visualComponent: getWordComponent('financialFutures')
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'financialFutureNoOfYearsTraded',
                    pattern: globalConfig?.regex?.number,
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: 'radioGroup',
                  props: {
                    name: 'financialFutureFrequencyOfTrades',
                    minHeight: '0',
                    flexWrapperMinHeight: '0',
                    removeButtonMargins: true,
                    removeLabelEllipsis: true,
                    flexProperties: true,
                    dataList: [
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed1',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.lessThanTen'),
                        value: 'lessThanTen',
                      },
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed2',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.moreOrEqualThanTen'),
                        value: 'moreOrEqualThanTen',
                      },
                    ],
                    required: true
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'financialFutureValueOfAverageDeal',
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: '',
                  visualComponent: getWordComponent('lots-3')
                },
              ]
            },
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '2fr 1fr 2fr 2fr 0.5fr',
                border: '1px #CDD2DC solid',
                topBorder: '0',
                padding: '16px',
                boxSizing: 'border-box'
              },
              content: [
                {
                  componentType: '',
                  visualComponent: getWordComponent('financialOptions')
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'financialOptionsNoOfYearsTraded',
                    pattern: globalConfig?.regex?.number,
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: 'radioGroup',
                  props: {
                    name: 'financialOptionsFrequencyOfTrades',
                    minHeight: '0',
                    flexWrapperMinHeight: '0',
                    removeButtonMargins: true,
                    removeLabelEllipsis: true,
                    flexProperties: true,
                    dataList: [
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed1',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.lessThanTen'),
                        value: 'lessThanTen',
                      },
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed2',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.moreOrEqualThanTen'),
                        value: 'moreOrEqualThanTen',
                      },
                    ],
                    required: true
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'financialOptionsValueOfAverageDeal',
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: '',
                  visualComponent: getWordComponent('lots-4')
                },
              ]
            },
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '2fr 1fr 2fr 2fr 0.5fr',
                border: '1px #CDD2DC solid',
                topBorder: '0',
                padding: '16px',
                boxSizing: 'border-box'
              },
              content: [
                {
                  componentType: '',
                  visualComponent: getWordComponent('commodityFutures')
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'commodityFuturesNoOfYearsTraded',
                    pattern: globalConfig?.regex?.number,
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: 'radioGroup',
                  props: {
                    name: 'commodityFuturesFrequencyOfTrades',
                    minHeight: '0',
                    flexWrapperMinHeight: '0',
                    removeButtonMargins: true,
                    removeLabelEllipsis: true,
                    flexProperties: true,
                    dataList: [
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed1',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.lessThanTen'),
                        value: 'lessThanTen',
                      },
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed2',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.moreOrEqualThanTen'),
                        value: 'moreOrEqualThanTen',
                      },
                    ],
                    required: true
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'commodityFuturesValueOfAverageDeal',
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: '',
                  visualComponent: getWordComponent('lots-5')
                },
              ]
            },
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '2fr 1fr 2fr 2fr 0.5fr',
                border: '1px #CDD2DC solid',
                topBorder: '0',
                padding: '16px',
                boxSizing: 'border-box'
              },
              content: [
                {
                  componentType: '',
                  visualComponent: getWordComponent('commodityOptions')
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'commodityOptionsNoOfYearsTraded',
                    pattern: globalConfig?.regex?.number,
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: 'radioGroup',
                  props: {
                    name: 'commodityOptionsFrequencyOfTrades',
                    minHeight: '0',
                    flexWrapperMinHeight: '0',
                    removeButtonMargins: true,
                    removeLabelEllipsis: true,
                    flexProperties: true,
                    dataList: [
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed1',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.lessThanTen'),
                        value: 'lessThanTen',
                      },
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed2',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.moreOrEqualThanTen'),
                        value: 'moreOrEqualThanTen',
                      },
                    ],
                    required: true
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'commodityOptionsValueOfAverageDeal',
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: '',
                  visualComponent: getWordComponent('lots-6')
                },
              ]
            },
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '2fr 1fr 2fr 2fr 0.5fr',
                border: '1px #CDD2DC solid',
                topBorder: '0',
                padding: '16px',
                boxSizing: 'border-box'
              },
              content: [
                {
                  componentType: '',
                  visualComponent: getWordComponent('cfds')
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'cfcDsNoOfYearsTraded',
                    pattern: globalConfig?.regex?.number,
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: 'radioGroup',
                  props: {
                    name: 'cfcDsFrequencyOfTrades',
                    minHeight: '0',
                    flexWrapperMinHeight: '0',
                    removeButtonMargins: true,
                    removeLabelEllipsis: true,
                    flexProperties: true,
                    dataList: [
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed1',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.lessThanTen'),
                        value: 'lessThanTen',
                      },
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed2',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.moreOrEqualThanTen'),
                        value: 'moreOrEqualThanTen',
                      },
                    ],
                    required: true
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'cfcDsValueOfAverageDeal',
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: '',
                  visualComponent: getWordComponent('value-7')
                },
              ]
            },
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '2fr 1fr 2fr 2fr 0.5fr',
                border: '1px #CDD2DC solid',
                topBorder: '0',
                padding: '16px',
                boxSizing: 'border-box'
              },
              content: [
                {
                  componentType: '',
                  visualComponent: getWordComponent('spotAndFoward')
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'spotForeignExchangeNoOfYearsTraded',
                    pattern: globalConfig?.regex?.number,
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: 'radioGroup',
                  props: {
                    name: 'spotForeignExchangeFrequencyOfTrades',
                    minHeight: '0',
                    flexWrapperMinHeight: '0',
                    removeButtonMargins: true,
                    removeLabelEllipsis: true,
                    flexProperties: true,
                    dataList: [
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed1',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.lessThanTen'),
                        value: 'lessThanTen',
                      },
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed2',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.moreOrEqualThanTen'),
                        value: 'moreOrEqualThanTen',
                      },
                    ],
                    required: true
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'spotForeignExchangeValueOfAverageDeal',
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: '',
                  visualComponent: getWordComponent('value-8')
                },
              ]
            },
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '2fr 1fr 2fr 2fr 0.5fr',
                border: '1px #CDD2DC solid',
                topBorder: '0',
                padding: '16px',
                boxSizing: 'border-box'
              },
              content: [
                {
                  componentType: '',
                  visualComponent: getWordComponent('funds')
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'fundsNoOfYearsTraded',
                    pattern: globalConfig?.regex?.number,
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: 'radioGroup',
                  props: {
                    name: 'fundsFrequencyOfTrades',
                    minHeight: '0',
                    flexWrapperMinHeight: '0',
                    removeButtonMargins: true,
                    removeLabelEllipsis: true,
                    flexProperties: true,
                    dataList: [
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed1',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.lessThanTen'),
                        value: 'lessThanTen',
                      },
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed2',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.moreOrEqualThanTen'),
                        value: 'moreOrEqualThanTen',
                      },
                    ],
                    required: true
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'fundsValueOfAverageDeal',
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: '',
                  visualComponent: getWordComponent('value-9')
                },
              ]
            },
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '2fr 1fr 2fr 2fr 0.5fr',
                border: '1px #CDD2DC solid',
                topBorder: '0',
                padding: '16px',
                boxSizing: 'border-box'
              },
              content: [
                {
                  componentType: '',
                  visualComponent: getWordComponent('otcAndOtherOff')
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'overTheCounterNoOfYearsTraded',
                    pattern: globalConfig?.regex?.number,
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: 'radioGroup',
                  props: {
                    name: 'overTheCounterFrequencyOfTrades',
                    minHeight: '0',
                    flexWrapperMinHeight: '0',
                    removeButtonMargins: true,
                    removeLabelEllipsis: true,
                    flexProperties: true,
                    dataList: [
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed1',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.lessThanTen'),
                        value: 'lessThanTen',
                      },
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed2',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.moreOrEqualThanTen'),
                        value: 'moreOrEqualThanTen',
                      },
                    ],
                    required: true
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'overTheCounterValueOfAverageDeal',
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: '',
                  visualComponent: getWordComponent('value-10')
                },
              ]
            },
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '2fr 1fr 2fr 2fr 0.5fr',
                border: '1px #CDD2DC solid',
                topBorder: '0',
                padding: '16px',
                boxSizing: 'border-box'
              },
              content: [
                {
                  componentType: '',
                  visualComponent: getWordComponent('spreadBetting')
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'spreadBettingNoOfYearsTraded',
                    pattern: globalConfig?.regex?.number,
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: 'radioGroup',
                  props: {
                    name: 'spreadBettingFrequencyOfTrades',
                    minHeight: '0',
                    flexWrapperMinHeight: '0',
                    removeButtonMargins: true,
                    removeLabelEllipsis: true,
                    flexProperties: true,
                    dataList: [
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed1',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.lessThanTen'),
                        value: 'lessThanTen',
                      },
                      {
                        id: 'isFinancialInstrumentsPortfolioExceed2',
                        label: t('onboarding.forms.IndividualAccount.ExperienceForm.inputs.radioGroup.moreOrEqualThanTen'),
                        value: 'moreOrEqualThanTen',
                      },
                    ],
                    required: true
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'spreadBettingValueOfAverageDeal',
                    minHeight: '0',
                    marginBottom: '0',
                    flexProperties: true,
                    inputStyleMargin: '0',
                    required: true
                  }
                },
                {
                  componentType: '',
                  visualComponent: getWordComponent('value-11')
                },
              ]
            },
          ]
        },
        {
          componentType: 'radioGroup',
          props: {
            name: 'isFinancialInstrumentsPortfolioExceed',
            minHeight: '0',
            margin: '16px 0 20px',
            marginBottom: '8px',
            flexWrapperMinHeight: '0',
            removeLabelEllipsis: true,
            dataList: [
              {
                id: 'isFinancialInstrumentsPortfolioExceed1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'isFinancialInstrumentsPortfolioExceed2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true
          },
        },
        {
          componentType: 'radioGroup',
          props: {
            name: 'isTypeOfInvestment',
            minHeight: '0',
            margin: '0 0 20px',
            marginBottom: '8px',
            removeLabelEllipsis: true,
            dataList: [
              {
                id: 'isTypeOfInvestment1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'isTypeOfInvestment2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true
          },
        },
      ],
    },
  ],
})

export default config
